var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.enabled)?_c('v-list-item',[_c('v-icon',{staticClass:"mr-3"},[_vm._v(" $version ")]),_c('span',{staticClass:"text--disabled"},[_vm._v(" "+_vm._s(_vm.$t('base.version') + ' ' + _vm.version)+" ")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }